<template>
    <div class="page">
        <el-form ref="form" :model="attributeWholeList" label-width="70px">
            <el-tabs type="border-card">
                <el-tab-pane label="基本信息">
                    <information-edit
                        ref="form1"
                    ></information-edit>
                </el-tab-pane>
                <el-tab-pane label="商品相册">
                    <el-form-item label="商品相册" prop="productAlbum">
                        <el-upload
                            :headers="header"
                            class="uploadAlbum"
                            :action="action"
                            :on-remove="handleRemove"
                            :file-list="fileList"
                            :on-success="handleSuccess"
                            :before-upload="beforeAvatarUpload"
                            list-type="picture"
                            accept="jpg,jpeg,png,JPG,JPEG,PNG"
                            :limit="10"
                            :disabled="stateDisabled"
                        >
                            <el-button size="small" :disabled="stateDisabled" type="primary">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传jpg,jpeg,png,JPG,JPEG,PNG文件，且不超过50MB</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="商品视频" prop="productAlbum">
                        <el-upload
                            class="uploadAlbum"
                            action=""
                            :disabled="stateDisabled"
                            :file-list="videoFileList"
                            :before-upload="handleBeforeUpload"
                            :on-remove="handleVodRemove"
                            :http-request="uploadAvatar"
                            :on-success="onSucc"
                            list-type="picture"
                            :limit="1"
                        >
                            <el-button size="small" type="primary" :disabled="stateDisabled">点击上传</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传mp4文件，且不超过{{fileSize}}mb</div>
                        </el-upload>
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="商品描述">
                    <el-form-item label="商品简介" prop="saleStatement">
                        <el-input
                            type="textarea"
                            style="width: 800px"
                            :disabled="stateDisabled"
                            size="small"
                            :rows="3"
                            v-model="attributeWholeList.saleStatement"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="商品详情" prop="productContent">
                        <WangEditor ref="contentEditor" :disabled="stateDisabled" v-model="attributeWholeList.productContent" />
                    </el-form-item>
                </el-tab-pane>
                <el-tab-pane label="商品属性">
                    <spu-edit ref="form2"></spu-edit>
                </el-tab-pane>
                <el-tab-pane label="商品规格">
                    <sku-edit ref="form3" :shopProduct="shopProduct"></sku-edit>
                </el-tab-pane>
                <!-- <el-form-item style="text-align: right; margin-bottom: 0">
                    <el-button v-if="shopProductState != 'check'" type="primary" @click="submitForm">修改</el-button>
                    <el-button @click="closeDialog">关闭</el-button>
                </el-form-item> -->
            </el-tabs>
        </el-form>
    </div>
</template>

<script>
import InformationEdit from '../../components/shop/InformationEdit.vue';
import spuEdit from '../../components/shop/spuEdit.vue';
import skuEdit from '../../components/shop/skuEdit.vue';
import WangEditor from '@/components/common/wangeditor';
import { get, post, postJson, upload } from '@/utils/request.js';
import eventBus from '../../api/eventBus';
import { UPLOAD_API,UPLOAD_PATH,UPLOAD_PATH_VIDEO } from '@/utils/constant.js';

export default {
    components: {
        InformationEdit,
        spuEdit,
        skuEdit,
        WangEditor
    },
    props: {
        shopProduct: {
            type: Object,
            default: {}
        },
        shopProductState: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            attributeWholeList: {
                productContent: '',
                saleStatement: '',
                productAlbum: '',
                productVideo: '',
            },
            albumList: '',
            isScoreList: [
                {
                    value: 0,
                    label: '否'
                },
                {
                    value: 1,
                    label: '是'
                }
            ],
            header: {
                token: localStorage.getItem('token')
            },
            fileList: [],
            videoFileList: [],

            temporaryList: [],
            stateDisabled: false,
            action: UPLOAD_API + UPLOAD_PATH,
            fileType: ['mp4'],
            // 上传文件大小限制(MB)
            fileSize: '100'
        };
    },
    created() {},
    watch: {
        // 监听分类id
        shopProduct: {
            handler(newVal, oldVal) {
                if (Object.keys(newVal).length != 0) {
                    this.attributeWholeList = { ...this.attributeWholeList, ...newVal };
                    //视频不为空
                    this.videoFileList = [];
                    if (this.attributeWholeList.productVideo) {
                        this.videoFileList.push({
                            name: this.attributeWholeList.productVideo,
                            url: this.attributeWholeList.productVideo
                        });
                    }

                    console.log(this.videoFileList);
                    this.$refs.contentEditor.init(this.attributeWholeList.productContent);
                    console.log(this.attributeWholeList);
                    eventBus.$emit('shopProduct', this.attributeWholeList, this.shopProductState);
                    this.fileList = [];
                    if (this.attributeWholeList.productAlbum) {
                        let str = this.attributeWholeList.productAlbum;
                        var list = str.split('|');

                        this.fileList = list.map((item) => {
                            return {
                                name: item,
                                url: item
                            };
                        });
                        this.temporaryList = [];
                        for (let item of list) {
                            this.temporaryList.push(item);
                        }
                        this.albumList = '';
                        this.albumList = this.temporaryList.join('|');
                    }
                    console.log(this.temporaryList);

                    if (this.attributeWholeList.spuList.length != 0) {
                        eventBus.$emit('spuList', this.attributeWholeList.spuList, this.shopProductState);
                    }
                    if (this.attributeWholeList.skuList.length != 0 || this.attributeWholeList.skuValueList.length != 0) {
                        eventBus.$emit(
                            'skuList',
                            this.attributeWholeList.skuList,
                            this.attributeWholeList.skuValueList,
                            this.shopProductState
                        );
                    }
                }
                console.log(this.fileList);
                console.log(newVal);
            },
            immediate: true,
            deep: true
        },
        shopProductState: {
            handler(newVal, oldVal) {
                if (newVal == 'check') {
                    this.stateDisabled = true;
                } else {
                    this.stateDisabled = false;
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        // change() {
        //     console.log(this.attributeWholeList.productType);
        // },
        // 删除图片
        handleRemove(file, fileList) {
            for (let i = 0; i < this.temporaryList.length; i++) {
                if (!file.response) {
                    if (file.url == this.temporaryList[i]) {
                        this.temporaryList.splice(i, 1);
                    }
                } else {
                    if (file.response.url == this.temporaryList[i]) {
                        this.temporaryList.splice(i, 1);
                    }
                }
            }
            this.albumList = this.temporaryList.join('|');
        },
        //上传成功
        handleSuccess(response, file, fileList) {
            console.log(this.temporaryList);
            console.log(file);
            console.log(fileList);
            // this.temporaryList = [];
            this.temporaryList.push(file.response.url);
            console.log(this.temporaryList);
            this.albumList = this.temporaryList.join('|');

            console.log(this.albumList);
        },
        //上传图片限制
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        aa() {
            console.log(222222);
        },

        // 生成唯一Id
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },

        // 关闭
        closeDialog() {
            this.$refs.form3.tableData = [];
            this.$refs.form3.skuList = [];
            this.$refs.form2.attributeForm.attributeList = [];
        },
        //上传视频
        uploadAvatar(params) {
            const file = params.file;
            console.log(file);
            // let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            // if (!types.includes(file.type)) {
            //     this.$message.error('图片类型错误!');
            // }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(UPLOAD_PATH_VIDEO, formData).then((res) => {
                if (res.success) {
                    this.attributeWholeList.productVideo = res.url;
                    console.log(this.attributeWholeList.productVideo);
                    console.log(this.videoFileList);
                }
            });
        },
        // 上传前校检格式和大小
        handleBeforeUpload(file) {
            console.log(this.attributeWholeList.productVideo);
            if (this.attributeWholeList.productVideo != '' && this.attributeWholeList.productVideo != null) {
                this.$message({
                    message: '最多上传一个视频',
                    type: 'info',
                    duration: 2000
                });
                return false;
            }
            // 校检文件类型
            if (this.fileType && file) {
                let fileExtension = '';
                if (file.name.lastIndexOf('.') > -1) {
                    fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
                }
                const isTypeOk = this.fileType.some((type) => {
                    if (file.type.indexOf(type) > -1) return true;
                    if (fileExtension && fileExtension.indexOf(type) > -1) return true;
                    return false;
                });
                if (!isTypeOk && file) {
                    this.$message({
                        message: `文件格式不正确, 请上传${this.fileType.join('/')}格式文件!`,
                        type: 'error',
                        duration: 2000
                    });
                    return false;
                }
            }
            // 校检文件大小;
            if (this.fileSize && file) {
                const isLt = file.size / 1024 / 1024 < this.fileSize;
                if (!isLt) {
                    this.$message({
                        message: `上传文件大小不能超过 ${this.fileSize} MB!`,
                        type: 'error',
                        duration: 2000
                    });
                    return false;
                }
            }

            return true;
        },
        handleVodRemove(file, fileList) {
            // console.log(file);
            // console.log(fileList);
            if (fileList.length == 0) {
                this.attributeWholeList.productVideo = '';
                this.videoFileList = [];
            }
        },

        // 提交修改
        submitForm() {
            // return;
            if (!this.$refs.form1.validateForm()) {
                this.$message({
                    message: '基本信息页没有填写完整',
                    type: 'error',
                    duration: 2000
                });
                return;
            }
            if (!this.$refs.form2.validateForm()) {
                this.$message({
                    message: '商品属性没有填写完整',
                    type: 'error',
                    duration: 2000
                });
                return;
            }
            let spuList = [];
            let spuValueList = [];
            let skuList = [];
            let skuValueList = [];

            let arr1 = this.$refs.form2.attributeForm.attributeList;
            let arr2 = this.$refs.form3.tableData;
            skuList = this.$refs.form3.skuList;

            // el-input 绑定多为字符串，接口需要 number
            const numRatio = (v) => {
                const n = Number(v);
                return Number.isFinite(n) ? n : 0;
            };

            // console.log(arr3);
            for (let item of arr1) {
                // let id = this.guid();
                // let reg = new RegExp('-', 'g');
                // id = id.replace(reg, '');
                // console.log(id);
                spuList.push({
                    id: item.id,
                    isRequired: item.isRequired,
                    nameKvId: item.nameKvId,
                    valueKvIds: item.valueKvIds,
                    valueType: item.valueType,
                    spuValue: {
                        id: item.spuValue.id,
                        spuId: item.id,
                        value: item.valueType == 1 ? item.spuValue.value : item.spuValue.value
                    }
                });
                // spuValueList.push({
                //     id: item.spuValue.id,
                //     spuId: item.id,
                //     value: item.valueType == 1 ? item.spuValue.value : item.spuValue.value
                // });
            }
            console.log('spuList',spuList);
            console.log('spuValueList',spuValueList);

            // return;
            for (let item of arr2) {
                skuValueList.push({
                    id: item.id,
                    skuKvIds: item.skuKvIds,
                    price: item.price,
                    stock: item.stock,
                    pic: item.pic,
                    supplyPrice: item.supplyPrice,
                    vbaoEnterRatio: numRatio(item.vbaoEnterRatio)
                });
            }

            this.attributeWholeList.productAlbum = this.albumList;

            let product = this.$refs.form1.shopProduct;
            let supplyChainProduct = this.$refs.form1.selectDialogData;

            delete product.productContent;
            delete product.saleStatement;
            delete product.productAlbum;
            delete product.isScore;
            delete product.scoreType;

            // 商品不为积分商品时清楚所需积分
            if(product.productType!=2){
                product.productScore = 0
            }

            let shopProduct = {
                ...this.attributeWholeList,
                ...product,
                productVideo: this.attributeWholeList.productVideo,
                spuList: spuList,
                spuValueList: spuValueList,
                skuList: skuList,
                skuValueList: skuValueList
            };

            if (
                shopProduct.vbaoEnterRatio !== undefined &&
                shopProduct.vbaoEnterRatio !== null &&
                shopProduct.vbaoEnterRatio !== ''
            ) {
                shopProduct.vbaoEnterRatio = numRatio(shopProduct.vbaoEnterRatio);
            }

            if(shopProduct.isSupplyChain === 1) {
                shopProduct.supplyProductId = supplyChainProduct.proId
                shopProduct.supplyProductCode = supplyChainProduct.proNo
                shopProduct.supplySkuCode = supplyChainProduct.row.skuNo
            } else {
                shopProduct.supplyProductId = ""
                shopProduct.supplyProductCode = ""
                shopProduct.supplySkuCode = ""
            }

            delete shopProduct.isSupplyChain
            delete shopProduct.supplyChainProduct

            let storageRemarkName = this.$store.state.userInfo.userName + '_storageRemarkList'
            let storageRemarkList = JSON.parse(localStorage.getItem(storageRemarkName)) || {}

            if (shopProduct.storageRemark) {
                storageRemarkList[shopProduct.productNumber] = shopProduct.storageRemark

                localStorage.setItem(storageRemarkName, JSON.stringify(storageRemarkList))
            }

            delete shopProduct.storageRemark

            console.log('shopProduct',shopProduct,supplyChainProduct);

            postJson('/shop/product/edit', { ...shopProduct }).then((res) => {
                if (res.success && res.code == 200) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.$emit('closeDialog', true);
                    this.closeDialog();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                    // this.$emit('closeDialog', true);
                }
            });
        },
        onSucc(response, file, fileList) {
            console.log(this.videoFileList);
        }
    }
};
</script>

<style lang="scss" scoped>
// ::v-deep .el-upload {
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
//     width: 200px;
//     height: 200px;
// }
</style>
